import { Link } from 'react-router-dom';

const footerLinks = {
  categories: [
    { label: '日本无码', path: '/category/japan-uncensored' },
    { label: '韩国无码', path: '/category/korea-uncensored' },
    { label: '东南亚无码', path: '/category/southeast-asia' },
    { label: '国产无码', path: '/category/china-uncensored' },
  ],
  guides: [
    { label: '平台选择指南', path: '/article/how-to-choose-legal-platform' },
    { label: '版权合规须知', path: '/article/copyright-compliance-adult-content' },
    { label: '内容分级制度', path: '/article/content-rating-system-guide' },
    { label: '支付安全指南', path: '/article/payment-safety-adult-platforms' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '免责声明', path: '/about' },
    { label: '隐私政策', path: '/about' },
    { label: '联系我们', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-shield-check-line text-xl text-primary-400"></i>
              </span>
              <span className="font-heading font-semibold text-base text-background-50">
                亚洲无码正版指南
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              致力于为中文用户提供亚洲无码正版内容平台的客观推荐与合规观看指南，
              帮助用户安全、合法地获取优质影音资源。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-100 mb-4">
              <a href="/category/japan-uncensored" className="hover:text-primary-400 transition-colors">内容分类</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-100 mb-4">
              <a href="/article/how-to-choose-legal-platform" className="hover:text-primary-400 transition-colors">观看指南</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.guides.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-100 mb-4">
              <a href="/about" className="hover:text-primary-400 transition-colors">关于本站</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 亚洲无码正版内容平台推荐指南. 本站为信息聚合平台，不提供内容存储或播放服务。
          </p>
          <p className="text-xs text-background-500">
            本站内容仅供成年人参考，未成年人请勿浏览。
          </p>
        </div>
      </div>
    </footer>
  );
}